<template>
    <form-wrapper class="intake-confirm" @submit="handleFormSubmission(data)">
        <intake-form-section>
            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.confirm_submit.fields.signature_name.label')"
                        :placeholder="$t('forms.intake.confirm_submit.fields.signature_name.placeholder')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="signatureName"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <checkbox-field :formData="data" valuePath="confirmationAccepted" @change="change($event)">
                        <template #label>
                            <span>{{ $t('forms.intake.confirm_submit.fields.confirmation.label') }}</span>
                        </template>
                    </checkbox-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <div class="intake-confirm__actions" :class="{ 'intake-confirm__actions--stacked': stackedActions }">
                <common-button
                    class="intake-confirm__back"
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    class="intake-confirm__submit"
                    :label="$t('forms.intake.confirm_submit.actions.submit')"
                    type="primary"
                    size="large"
                    :isProcessing="isSubmitting"
                    :isDisabled="!canSubmit || isSubmitting"
                ></common-button>
            </div>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
            isSubmitting: { type: Boolean, default: false },
            stackedActions: { type: Boolean, default: false },
        },

        data() {
            return {
                data: {
                    signatureName: undefined,
                    confirmationAccepted: false,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            canSubmit() {
                return Boolean(String(this.data.signatureName || '').trim()) && Boolean(this.data.confirmationAccepted)
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                if (!this.canSubmit || this.isSubmitting) {
                    return
                }

                this.emitSent(data)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';

    .intake-confirm__actions {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: rem(12px);
    }

    .intake-confirm__back {
        order: 1;
    }

    .intake-confirm__submit {
        order: 2;
    }

    .intake-confirm__actions ::v-deep .button {
        width: auto;
        flex: 0 0 auto;
    }

    .intake-confirm__actions--stacked {
        flex-direction: column;
        align-items: stretch;
    }

    .intake-confirm__actions--stacked .intake-confirm__submit {
        order: 1;
    }

    .intake-confirm__actions--stacked .intake-confirm__back {
        order: 2;
    }

    .intake-confirm__actions--stacked ::v-deep .button {
        width: 100%;
        flex: 0 0 auto;
    }
</style>
